import { Radio } from "lucide-react";

const FEED = [
  {
    id: "act-1",
    tick: "blue",
    pill: { tone: "blue", label: "Processing", pulse: true },
    time: "2 min ago",
    agent: "Voiceflow Voice Agent",
    text: "called Sarah Chen, Midwest Health Systems — Left voicemail, SMS follow-up queued",
  },
  {
    id: "act-2",
    tick: "amber",
    pill: { tone: "teal", label: "Active" },
    time: "11 min ago",
    agent: "Make.com Email Agent",
    text: "Day 7 touchpoint sent to Dr. Marcus Webb, Regional Surgical — Opened (98% SMS open rate, email pending)",
  },
  {
    id: "act-3",
    tick: "red",
    pill: { tone: "red", label: "Stalled" },
    time: "34 min ago",
    agent: "Scoring Agent",
    text: "Lead disqualified after 5 touches — no response. Removed from sequence. Acquisition cost: $186.",
  },
  {
    id: "act-4",
    tick: "green",
    pill: { tone: "green", label: "Success" },
    time: "1 hr ago",
    agent: "CONVERTED",
    text: "James Park, NovaMed Instruments — Booked demo via SMS link. Pipeline value: $14,000",
  },
  {
    id: "act-5",
    tick: "green",
    pill: { tone: "green", label: "Success" },
    time: "2 hr ago",
    agent: "Voice Agent",
    text: "Inbound callback from Dr. Lisa Tran — Qualification complete, routed to rep",
  },
];

function Pill({ tone, label, pulse }) {
  const cls = {
    teal: "pill pill-teal",
    blue: "pill pill-blue",
    amber: "pill pill-amber",
    green: "pill pill-green",
    red: "pill pill-red",
  }[tone];
  return (
    <span className={cls}>
      <span className={`pill-dot ${pulse ? "pill-dot-pulse" : ""}`} />
      {label}
    </span>
  );
}

export default function LiveActivity() {
  return (
    <article data-testid="live-activity-card" className="card-glass p-6 h-full">
      <header className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2.5">
          <div
            className="flex items-center justify-center rounded-md"
            style={{ width: 28, height: 28, background: "rgba(0, 194, 168, 0.10)", border: "1px solid rgba(0, 194, 168, 0.25)" }}
          >
            <Radio size={14} color="#00C2A8" />
          </div>
          <div>
            <h2
              style={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
                fontSize: 15,
                letterSpacing: "-0.01em",
                color: "var(--text-primary)",
              }}
            >
              Live Nurture Activity
            </h2>
            <div
              style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 10,
                letterSpacing: "0.12em",
                color: "var(--text-muted)",
                textTransform: "uppercase",
              }}
            >
              Agents streaming · updated live
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="pill pill-teal">
            <span className="pill-dot pill-dot-pulse" />
            Live
          </span>
        </div>
      </header>

      <div data-testid="live-feed" className="max-h-[430px] overflow-y-auto pr-1">
        {FEED.map((f, i) => (
          <div
            key={f.id}
            data-testid={f.id}
            className="feed-row enter-up"
            style={{ animationDelay: `${i * 70}ms` }}
          >
            <span className={`feed-tick ${f.tick}`} />
            <div className="min-w-0">
              <div
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: 13,
                  lineHeight: 1.55,
                  color: "var(--text-primary)",
                }}
              >
                <span
                  style={{
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: 11,
                    color: "#0EA5E9",
                    marginRight: 8,
                  }}
                >
                  {f.agent}:
                </span>
                {f.text}
              </div>
              <div
                className="mt-1.5"
                style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: 10,
                  color: "var(--text-muted)",
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                }}
              >
                {f.time}
              </div>
            </div>
            <Pill {...f.pill} />
          </div>
        ))}
      </div>
    </article>
  );
}
